(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[53809],{

/***/ 34190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Media; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Media/utils/helpers.js
var videoFormats = function(format) {
    return [
        "video/mp4",
        "video/webm", 
    ].includes(format);
};

;// CONCATENATED MODULE: ./UI/components/Media/utils/useMediaProps.js







/* harmony default export */ function useMediaProps(_param) {
    var asset = _param.asset, className = _param.className, isStatic = _param.isStatic, transparent = _param.transparent, loaderParams = _param.loaderParams, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "asset",
        "className",
        "isStatic",
        "transparent",
        "loaderParams"
    ]);
    var ref = (0,react.useRef)(null);
    var ref1 = get_default()(asset, "fields", {}), contentType = ref1.file.contentType;
    var isVideo = videoFormats(contentType);
    var ref2 = (0,helper/* getImage */.gJ)(asset), url = ref2.url, alt = ref2.alt;
    var imageProps = (0,_object_spread/* default */.Z)({
        alt: alt,
        src: url,
        layout: "fill",
        lazyBoundary: "700px",
        unoptimized: true,
        loader: isStatic ? function(param) {
            var src = param.src;
            return src;
        } : function(args) {
            return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
                transparent: transparent
            }, args, loaderParams));
        }
    }, rest);
    return (0,_object_spread/* default */.Z)({
        ref: ref,
        url: url,
        isVideo: isVideo,
        className: className,
        imageProps: imageProps
    }, rest);
};

// EXTERNAL MODULE: ./UI/components/Media/styles.module.scss
var styles_module = __webpack_require__(6992);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Media/index.jsx










var Media = function(_param) {
    var renderVideoPlayer = _param.renderVideoPlayer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "renderVideoPlayer"
    ]);
    var _ref = useMediaProps(props), ref = _ref.ref, url = _ref.url, isVideo = _ref.isVideo, className = _ref.className, imageProps = _ref.imageProps, playControl = _ref.playControl, posterUrl = _ref.posterUrl, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref",
        "url",
        "isVideo",
        "className",
        "imageProps",
        "playControl",
        "posterUrl"
    ]);
    if (isVideo) {
        if (renderVideoPlayer) {
            return renderVideoPlayer({
                src: url,
                description: imageProps.alt
            });
        }
        if (playControl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["video-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    controls: true,
                    poster: posterUrl,
                    className: className
                }, rest), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/webm"
                        })
                    ]
                }))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            muted: true,
            autoPlay: true,
            loop: true,
            playsInline: true,
            className: className
        }, rest), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/webm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: url,
                    type: "video/mp4"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()((styles_module_default()).image, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, imageProps))
    });
};
Media.propTypes = {
    asset: prop_types_default().instanceOf(Object).isRequired,
    autoPlay: (prop_types_default()).bool,
    loop: (prop_types_default()).bool,
    playsInline: (prop_types_default()).bool,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    renderVideoPlayer: (prop_types_default()).func
};
/* harmony default export */ var components_Media = (Media);


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40659);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var UI_components_Media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34190);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69123);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);













var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var GalleryCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 34378).then(__webpack_require__.bind(__webpack_require__, 34378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34378)
            ];
        }
    }
});
var ArticleLink = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7002).then(__webpack_require__.bind(__webpack_require__, 7002)).then(function(module) {
        return module.ArticleLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7002)
            ];
        }
    }
});
var Table = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 84059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var EmbedArticleCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 80931).then(__webpack_require__.bind(__webpack_require__, 80931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80931)
            ];
        }
    }
});
var Illustration = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 93812).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
// TODO move it to the common folder
// TODO create constants for cases
var ContentfulParser = function(param) {
    var document = param.document, linkIcon = param.linkIcon;
    var _obj, _obj1;
    var options = {
        renderMark: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.CODE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sub", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.BOLD, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.ITALIC, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                children: node
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.MARKS.UNDERLINE, function(node) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                children: node
            });
        }), _obj),
        renderNode: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var id = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target.sys.contentType.sys.id", "");
            switch(id){
                case "image":
                    {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", ""), [
                            "articleSingleImageType",
                            "image",
                            "title"
                        ]), articleSingleImageType = ref.articleSingleImageType, rawImage = ref.image, title = ref.title;
                        var image = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getImage */ .gJ)(rawImage);
                        var _obj;
                        return articleSingleImageType && image.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().normalImage), articleSingleImageType === "normal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fullImage), articleSingleImageType !== "normal"), _obj)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, {
                                        type: utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Illustration, {
                                            src: image.url,
                                            alt: image.alt,
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image)
                                        })
                                    }),
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().photoCaption),
                                        children: title
                                    })
                                ]
                            })
                        });
                    }
                case "articleGalleryCard":
                    {
                        var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "images",
                            "photoCaption"
                        ]), images = ref1.images, photoCaption = ref1.photoCaption;
                        return images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryCard, {
                            images: images,
                            photoCaption: photoCaption
                        });
                    }
                case "link":
                    {
                        var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref2 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data, [
                            "title",
                            "buttonTitle",
                            "slug",
                            "type",
                            "url",
                            "new", 
                        ]), title1 = ref2.title, buttonTitle = ref2.buttonTitle, slug = ref2.slug, type = ref2.type, url = ref2.url, isNew = ref2.new;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArticleLink, {
                            data: data,
                            new: isNew,
                            title: title1,
                            buttonTitle: buttonTitle,
                            slug: slug,
                            type: type,
                            url: url,
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().videoSection)
                        });
                    }
                case "table":
                    {
                        var ref3 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {}), [
                            "tableContent",
                            "tableType"
                        ]), tableContent = ref3.tableContent, tableType = ref3.tableType;
                        return tableContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Table, {
                            tableData: tableContent.tableData,
                            type: tableType
                        });
                    }
                case "article":
                    {
                        var data1 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedArticleCard, {
                            data: data1
                        });
                    }
                case "text":
                    {
                        var data2 = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
                        var ref4 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDocumentFields */ .OA)(data2, [
                            "text",
                            "id"
                        ]), text = ref4.text, entryId = ref4.id;
                        return(// eslint-disable-next-line react/no-unknown-property
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "grid-area": entryId,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentfulParser, {
                                document: text
                            })
                        }));
                    }
                default:
                    return null;
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var data = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.target", {});
            return(// eslint-disable-next-line react/no-unknown-property
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "grid-area": "asset",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Media__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    asset: data
                })
            }));
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().quote),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h3),
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ul),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(node, children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                type: "1",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ol),
                children: children === null || children === void 0 ? void 0 : children.map(function(child) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: child.props.children
                    }, child.key);
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj1, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
            var uri = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(node, "data.uri", "/");
            var isInternalLink = uri.includes(utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .rootUrl */ .Wd);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                path: uri,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().a),
                isLocalLink: isInternalLink,
                children: [
                    children,
                    linkIcon
                ]
            });
        }), _obj1)
    };
    return document ? (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(document, options) : "";
};
ContentfulParser.defaultProps = {
    document: null
};
ContentfulParser.propTypes = {
    document: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["default"] = (ContentfulParser);


/***/ }),

/***/ 65132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ TagsBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46376);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var TagsBlock = function(param) {
    var tags = param.tags;
    if (!tags) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tagsBlock),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().title),
                children: "Tags"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tagsList),
                children: tags.map(function(param) {
                    var title = param.title, slug = param.slug;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().tag),
                        children: title
                    }, title);
                })
            })
        ]
    });
};
TagsBlock.defaultProps = {
    tags: []
};
TagsBlock.propTypes = {
    tags: prop_types__WEBPACK_IMPORTED_MODULE_3___default().instanceOf(Array)
};


/***/ }),

/***/ 12656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BlogCommon_Article; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./hocs/withScroll.js
var withScroll = __webpack_require__(12512);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./components/Common/FullScreenEstimation/index.jsx
var FullScreenEstimation = __webpack_require__(92261);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./components/BlogCommon/Article/Author/styles.module.scss
var styles_module = __webpack_require__(70277);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/Author/index.jsx




var Author = function(param) {
    var _author = param.author, avatarImage = _author.avatarImage, fullName = _author.fullName, position = _author.position, slug = _author.slug;
    return avatarImage && fullName && position && (slug ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
        path: "/person/".concat(slug),
        className: (styles_module_default()).author,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat(avatarImage, ")")
                },
                className: (styles_module_default()).avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).authorInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: position
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).author,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat(avatarImage, ")")
                },
                className: (styles_module_default()).avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).authorInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: position
                    })
                ]
            })
        ]
    }));
};
Author.defaultProps = {
    author: {
        avatarImage: "",
        fullName: "",
        position: ""
    }
};
Author.propTypes = {
    author: prop_types_default().shape({
        avatarImage: (prop_types_default()).string,
        fullName: (prop_types_default()).string,
        position: (prop_types_default()).string
    })
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/BlogCommon/Article/NavigationByTitles/styles.module.scss
var NavigationByTitles_styles_module = __webpack_require__(2686);
var NavigationByTitles_styles_module_default = /*#__PURE__*/__webpack_require__.n(NavigationByTitles_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/NavigationByTitles/index.jsx
/* eslint-disable no-shadow */ 









var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var NavigationByTitles = function(param) {
    var articleBodyRef = param.articleBodyRef, articleSlug = param.articleSlug;
    var ref = (0,react.useState)([]), subtitles = ref[0], setSubtitles = ref[1];
    var ref1 = (0,react.useState)(false), isNavigationOpened = ref1[0], setIsNavigationOpened = ref1[1];
    var handleOnExpandClick = function() {
        return setIsNavigationOpened(!isNavigationOpened);
    };
    var handleOnItemClick = function(event) {
        var index = event.target.getAttribute("data-index");
        window.scrollBy({
            top: subtitles[index].element.getBoundingClientRect().top - constants/* HEADER_HEIGHT */.Mz,
            behavior: "smooth"
        });
        event.preventDefault();
    };
    (0,react.useEffect)(function() {
        if (articleBodyRef && articleBodyRef.current) {
            var subtitleRefs = articleBodyRef.current.getElementsByTagName("h2") || [];
            var subtitles = (0,_to_consumable_array/* default */.Z)(subtitleRefs).reduce(function(acc, subtitleRef) {
                var subtitle = subtitleRef.textContent;
                var slug = slugify_default()(subtitle);
                subtitleRef.setAttribute("id", slug);
                acc.push({
                    id: slug,
                    name: subtitle,
                    element: subtitleRef
                });
                return acc;
            }, []);
            setSubtitles(subtitles);
        }
        return function() {
            return setIsNavigationOpened(false);
        };
    }, [
        articleBodyRef,
        articleSlug
    ]);
    if (!subtitles.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NavigationByTitles_styles_module_default()).navigation,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NavigationByTitles_styles_module_default()).navigationHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NavigationByTitles_styles_module_default()).title,
                        children: "Contents"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (NavigationByTitles_styles_module_default()).expandButton,
                        onClick: handleOnExpandClick,
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (NavigationByTitles_styles_module_default()).buttonText,
                                children: isNavigationOpened ? "hide" : "expand"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((NavigationByTitles_styles_module_default()).arrow, (0,_define_property/* default */.Z)({}, (NavigationByTitles_styles_module_default()).reverseArrow, !isNavigationOpened)),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, {
                type: constants/* ANIMATED_TYPE.expandByHeight */.BK.expandByHeight,
                open: isNavigationOpened,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NavigationByTitles_styles_module_default()).navigationItems,
                    children: subtitles.map(function(subtitle, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            "data-index": index,
                            href: "#".concat(subtitle.id),
                            onClick: handleOnItemClick,
                            className: (NavigationByTitles_styles_module_default()).navigationLink,
                            children: "".concat(index + 1, ". ").concat(subtitle.name)
                        }, subtitle.id);
                    })
                })
            })
        ]
    });
};
NavigationByTitles.defaultProps = {
    articleBodyRef: null,
    articleSlug: ""
};
NavigationByTitles.propTypes = {
    articleBodyRef: prop_types_default().instanceOf(Object),
    articleSlug: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/BlogCommon/Article/styles.module.scss
var Article_styles_module = __webpack_require__(44932);
var Article_styles_module_default = /*#__PURE__*/__webpack_require__.n(Article_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/index.jsx













var OldArticle = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 75287).then(__webpack_require__.bind(__webpack_require__, 75287));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75287)
            ];
        }
    }
});
var Article = function(param) {
    var introSection = param.introSection, slug = param.slug, title = param.title, oldBody = param.oldBody, body = param.body, introduction = param.introduction, headImage = param.headImage, maxScrollPosition = param.maxScrollPosition, author = param.author, publishedAt = param.publishedAt;
    var articleBodyRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isFullscreenEstimationOpen = ref[0], setFullscreenEstimationOpen = ref[1];
    (0,react.useEffect)(function() {
        return function() {
            if (slug) {
                ga/* default.trackEvent */.Z.trackEvent("Scroll", "".concat(maxScrollPosition.current, "%"), "/blog/".concat(slug), maxScrollPosition.current < 50);
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        };
    }, [
        slug
    ]);
    var context = (0,react.useMemo)(function() {
        return {
            isShown: isFullscreenEstimationOpen,
            open: function() {
                return setFullscreenEstimationOpen(true);
            }
        };
    }, [
        isFullscreenEstimationOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: introSection,
        className: (Article_styles_module_default()).article,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (Article_styles_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: headImage.url,
                        alt: headImage.alt,
                        className: (Article_styles_module_default()).headImage,
                        priority: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Article_styles_module_default()).container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Article_styles_module_default()).date,
                                children: (0,helper/* formatDate */.p6)(publishedAt)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (Article_styles_module_default()).h1,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: introduction
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                                author: author
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Article_styles_module_default()).body,
                ref: articleBodyRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationByTitles, {
                        articleBodyRef: articleBodyRef,
                        articleSlug: slug
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenEstimation.FullscreenEstimationContext.Provider, {
                        value: context,
                        children: oldBody ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OldArticle, {
                            oldBody: oldBody
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                            document: body
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenEstimation["default"], {
                        isFullscreenEstimation: isFullscreenEstimationOpen,
                        closeFullscreenEstimation: function() {
                            return setFullscreenEstimationOpen(false);
                        }
                    })
                ]
            })
        ]
    });
};
Article.defaultProps = {
    oldBody: "",
    body: null,
    slug: "",
    title: "",
    introduction: "",
    publishedAt: ""
};
Article.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired,
    maxScrollPosition: prop_types_default().instanceOf(Object).isRequired,
    slug: (prop_types_default()).string,
    title: (prop_types_default()).string,
    oldBody: (prop_types_default()).string,
    body: prop_types_default().instanceOf(Object),
    introduction: (prop_types_default()).string,
    headImage: prop_types_default().instanceOf(Object).isRequired,
    author: prop_types_default().instanceOf(Object).isRequired,
    publishedAt: (prop_types_default()).string
};
/* harmony default export */ var BlogCommon_Article = ((0,withScroll/* default */.Z)(Article));


/***/ }),

/***/ 92261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FullscreenEstimationContext": function() { return /* binding */ FullscreenEstimationContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79897);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18422);
/* harmony import */ var UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56362);
/* harmony import */ var utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32522);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66723);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);










var FeedbackForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(33714), __webpack_require__.e(84602), __webpack_require__.e(43919), __webpack_require__.e(44141), __webpack_require__.e(78873), __webpack_require__.e(69773)]).then(__webpack_require__.bind(__webpack_require__, 3972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3972)
            ];
        }
    },
    ssr: false
});
var FullScreenEstimation = function(param) {
    var isFullscreenEstimation = param.isFullscreenEstimation, closeFullscreenEstimation = param.closeFullscreenEstimation, extraDescription = param.extraDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isModalWindow: isFullscreenEstimation,
        closeModalWindow: closeFullscreenEstimation,
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fullscreenEstimation),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().estimationContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    isBold: true,
                    children: "Got a project in mind?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                    children: [
                        "Fill in this form or",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            path: "mailto:".concat(utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__/* .EMAIL_LINK */ .Vr),
                            children: "send us an e-mail"
                        })
                    ]
                }),
                isFullscreenEstimation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedbackForm, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().feedbackForm),
                    isBudgetSlider: true,
                    formKey: "estimation",
                    extraDescription: extraDescription,
                    withoutAdditionalInfo: true
                })
            ]
        })
    });
};
FullScreenEstimation.propTypes = {
    isFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool.isRequired),
    closeFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().func.isRequired),
    extraDescription: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
var FullscreenEstimationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isShown: false,
    open: function() {
        return null;
    }
});
/* harmony default export */ __webpack_exports__["default"] = (FullScreenEstimation);


/***/ }),

/***/ 76259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getArticleProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6572);



function getAuthorProps() {
    var author = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).author;
    var authorFields = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(author, [
        "fullName",
        "position",
        "avatar",
        "slug", 
    ]);
    var avatarImage = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getFileUrl */ .qm)(authorFields.avatar);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, authorFields), {
        avatarImage: avatarImage
    });
}
function getFAQList(param) {
    var frequentlyAskedQuestions = param.frequentlyAskedQuestions;
    if (!frequentlyAskedQuestions) {
        return [];
    }
    return frequentlyAskedQuestions.map(function(question) {
        return (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(question, [
            "question",
            "answer"
        ]);
    });
}
function getTagsList(param) {
    var tagsList = param.tagsList;
    if (!tagsList) {
        return [];
    }
    return tagsList.map(function(question) {
        return (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(question, [
            "title",
            "slug"
        ]);
    });
}
function getArticleProps() {
    var article = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).article;
    var articleFields = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getDocumentFields */ .OA)(article, [
        "slug",
        "title",
        "description",
        "oldBody",
        "body",
        "introduction",
        "headImageUrl",
        "publishedAt",
        "updatedAt",
        "tagsList",
        "categoryTag",
        "metaTitle",
        "metaDescription",
        "author",
        "frequentlyAskedQuestions", 
    ]);
    var headImage = (0,utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getImage */ .gJ)(articleFields.headImageUrl);
    var author = getAuthorProps({
        author: articleFields.author
    });
    var faqList = getFAQList(articleFields);
    var tagsList = getTagsList(articleFields);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, articleFields), {
        headImage: headImage,
        author: author,
        faqList: faqList,
        tagsList: tagsList
    });
}


/***/ }),

/***/ 12512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_2__);




var withScroll = function(Component) {
    return function(props) {
        var maxScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
        var lastScrollTop = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
        var setMaxScrollPosition = function(value) {
            maxScrollPosition.current = value;
        };
        var setLastScrollTop = function(value) {
            lastScrollTop.current = value;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var saveScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function(scroll) {
            return setMaxScrollPosition(scroll);
        }, 500), []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var saveLastScrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function(scroll) {
            return setLastScrollTop(scroll);
        }, 500), []);
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            var getScrollPercent = function() {
                var documentElement = document.documentElement, body = document.body;
                var scrollTop = documentElement.scrollTop || body.scrollTop;
                var scrollHeight = documentElement.scrollHeight || body.scrollHeight;
                var scrollPercent = (scrollTop / (scrollHeight - documentElement.clientHeight) * 100).toFixed(2);
                switch(true){
                    case scrollPercent >= 0 && scrollPercent < 25:
                        return 25;
                    case scrollPercent >= 25 && scrollPercent < 50:
                        return 50;
                    case scrollPercent >= 50 && scrollPercent < 75:
                        return 75;
                    case scrollPercent >= 75 && scrollPercent <= 100:
                        return 100;
                    default:
                        return 25;
                }
            };
            var setMaxScroll = function() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                if (scrollTop > maxScrollPosition.current) {
                    var scrollPercent = getScrollPercent();
                    if (scrollPercent > maxScrollPosition.current) {
                        saveScrollPosition(scrollPercent);
                    }
                }
                saveLastScrollPosition(scrollTop <= 0 ? 0 : scrollTop);
            };
            window.addEventListener("scroll", setMaxScroll);
            return function() {
                window.removeEventListener("scroll", setMaxScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            maxScrollPosition: maxScrollPosition,
            lastScrollTop: lastScrollTop
        }, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withScroll);


/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__NnBr_","video-container":"styles_video-container__3YIN0","play-button":"styles_play-button__ubn_b"};

/***/ }),

/***/ 70277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"author":"styles_author__a2_uT","avatar":"styles_avatar__dA1c5","authorInfo":"styles_authorInfo___carz"};

/***/ }),

/***/ 69123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__BMuQY","h3":"styles_h3__wh4p0","paragraph":"styles_paragraph__9NG9P","a":"styles_a__QRxdK","ul":"styles_ul__esYyW","ol":"styles_ol__ue_m_","quote":"styles_quote___48vb","imageWrapper":"styles_imageWrapper__qFsnC","fullImage":"styles_fullImage__qANu4","normalImage":"styles_normalImage__eNnG6","image":"styles_image__Lejqj","photoCaption":"styles_photoCaption__WUS8x","videoSection":"styles_videoSection__g6E1A"};

/***/ }),

/***/ 2686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__zivU1","navigationHeader":"styles_navigationHeader__4odHK","title":"styles_title__DTas4","expandButton":"styles_expandButton__JmLeP","buttonText":"styles_buttonText__ylGUI","arrow":"styles_arrow__lNrmY","reverseArrow":"styles_reverseArrow__r7jbd","navigationItems":"styles_navigationItems__AefcT","navigationLink":"styles_navigationLink__F5aVn"};

/***/ }),

/***/ 46376:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tagsBlock":"styles_tagsBlock__lvVbj","title":"styles_title__BehH_","tagsList":"styles_tagsList__TBgCk","tag":"styles_tag__9QMpJ"};

/***/ }),

/***/ 44932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__Ixp2v","h3":"styles_h3__CooIR","paragraph":"styles_paragraph___jee6","body":"styles_body__90l3W","a":"styles_a__vtHH4","ul":"styles_ul__6w0UV","ol":"styles_ol__aNt50","quote":"styles_quote__EItiR","h1":"styles_h1__bBevL","headImage":"styles_headImage__bWWem","article":"styles_article__2Ifrk","header":"styles_header__BxSYV","container":"styles_container___xSqx","date":"styles_date__gWcLD"};

/***/ }),

/***/ 66723:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullscreenEstimation":"styles_fullscreenEstimation__Rg_DE","estimationContainer":"styles_estimationContainer__gixM_","feedbackForm":"styles_feedbackForm__cR1Pq","title":"styles_title__07SXR","subtitle":"styles_subtitle__fjFtJ"};

/***/ })

}]);